import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

// Import XSS protection utilities
import { xssDirective } from './utils/xss-protection.js';

// Import the global axios interceptor
import './utils/api.js';

import posthogPlugin from './plugins/posthog.js';
import posthog from 'posthog-js';

const app = createApp(App)

// Register XSS protection directive
app.directive('xss', xssDirective);

app.use(posthogPlugin);
app.use(router)
app.use(ToastPlugin);

const setHeadElement = (selector, attributes, content) => {
  let element = document.head.querySelector(selector);

  if (!content) {
    element?.remove();
    return;
  }

  if (!element) {
    element = document.createElement(attributes.rel ? 'link' : 'meta');
    Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
    document.head.appendChild(element);
  }

  element.setAttribute(attributes.rel ? 'href' : 'content', content);
};

router.afterEach((to) => {
  document.title = to.meta.title || 'BookedSolid';
  setHeadElement('meta[name="description"]', { name: 'description' }, to.meta.description);
  setHeadElement('link[rel="canonical"]', { rel: 'canonical' }, to.meta.canonical);
  setHeadElement('meta[name="robots"]', { name: 'robots' }, to.meta.noindex ? 'noindex' : '');

  posthog.capture('$pageview', { '$current_url': window.location.href })
})

app.mount('#app')
